import type { ForumUserRoles } from './forum'

export type NotificationType =
  // Post notifications
  | 'POST_UPDATED'
  | 'NEW_COMMENT' // post has new comment
  | 'NEW_REPLY' // comment has new reply
  | 'POST_HAVE_ANSWER' // followed post or your post have answer
  // Class
  | 'NEW_SUPPORT_POST'
  | 'NEW_ANNOUNCEMENT'
  // Report
  | 'REPORT_SUBMITED'
  | 'CONTENT_REPORTED_HIDDEN'
  | 'CONTENT_DELETED'

export type NotiAuthor = {
  profile_image?: string
  first_name: string
  last_name: string
  user_roles: ForumUserRoles[]
}

export type NotiTag = {
  id_slug: string
  slug_name: string
  name: string
  description: string
}

export type NotiPost = {
  id_slug: string
  tags: NotiTag[]
  author: NotiAuthor
  title: string
  description: string
  created_date: string
  modified_date: string
}

export type NotiCommentReply = {
  id_slug: string
  created_date: string
  modified_date: string
  post: {
    id_slug: string
    title: string
  }
  parent_comment?: NotiCommentReply
  author: NotiAuthor
  description: string
  is_answer: boolean
  upvote_count: number
  downvote_count: number
  total_vote_count: number
  is_hidden: boolean
}

export type NotificationData = {
  id: string
  user: NotiAuthor
  notification_type: string
  created_date: string
  modified_date: string
  is_read: boolean
  // noti content
  post?: NotiPost
  comment_reply?: NotiCommentReply
  report?: {
    id: string
    post?: NotiPost
    comment_reply?: NotiCommentReply
    reporter: NotiAuthor
  }
}

export const notiTypeContent = {
  // POST
  NEW_COMMENT: {
    title: 'New comment',
    description: `<b>AUTHOR_NAME</b> leaves a comment in the post "<b>POST_TITLE</b>".`,
    description_your: `You leave a comment in the post "<b>POST_TITLE</b>".`
  },
  NEW_REPLY: {
    title: 'New reply',
    description: `<b>AUTHOR_NAME</b> replied to your comment in post "<b>POST_TITLE</b>".`
  },
  POST_UPDATED: {
    title: 'Post updated',
    description: `There are new updates in <b>AUTHOR_NAME's</b> post "<b>POST_TITLE</b>".`,
    description_your: `There are new updates in your post "<b>POST_TITLE</b>".`
  },
  POST_HAVE_ANSWER: {
    title: 'New answer',
    description: `<b>AUTHOR_NAME's</b> post "<b>POST_TITLE</b>" has a new answer.`,
    description_your: `Your post "<b>POST_TITLE</b>" has a new answer.`
  },
  // CLASS
  NEW_CLASSROOM_ANNOUNCEMENT_POST: {
    title: 'New announcement',
    description: `Your class "<b>CLASS_TITLE</b>" has a new announcement.`
  },
  NEW_SUPPORT_POST: {
    title: 'New support post',
    description: `There is a new support post in the class "<b>CLASS_TITLE</b>".`
  },
  // REPORT
  REPORT_SUBMITED: {
    title: 'Report submitted',
    description: `Thank you for reporting. We're looking into the content "<b>POST_TITLE</b>"`
  },
  CONTENT_REPORTED_HIDDEN: {
    title: 'Reported content',
    description: `Your content "<b>POST_TITLE</b>" has been reported. We are currently reviewing your content. In the meantime, your content will be hidden.`
  },
  CONTENT_DELETED: {
    title: 'Content violation',
    description: `Your content "<b>POST_TITLE</b>" has been deleted for violating one of our community rules.`
  }
}

const tempUser: NotiAuthor = {
  profile_image: '/images/landing/landing-page/community/landing-community-42.png',
  first_name: 'Minji',
  last_name: 'Kim',
  user_roles: ['STUDENT']
}

export const tempNotifications: NotificationData[] = [
  // There is an update on a post - not your post
  {
    id: 'noti-0',
    user: tempUser,
    notification_type: 'POST_UPDATED',
    created_date: '2024-12-08T13:19:53.648Z',
    modified_date: '2024-12-08T13:19:53.648Z',
    is_read: false,
    post: {
      id_slug: 'post-0',
      tags: [
        {
          id_slug: 'tag-class-0',
          slug_name: 'kydp_cada_sept_24',
          name: 'KYDP CADA September Intake 2024',
          description: ''
        }
      ],
      author: {
        profile_image: '/images/landing/landing-page/community/landing-community-15.png',
        first_name: 'Jisoo',
        last_name: 'Kim',
        user_roles: ['STUDENT']
      },
      title: 'This is the title of the post',
      description: 'This is the description of the post',
      created_date: '2024-12-08T13:19:53.648Z',
      modified_date: '2024-12-08T13:19:53.648Z'
    }
  },
  // There is an update on a post - your post
  {
    id: 'noti-15',
    user: tempUser,
    notification_type: 'POST_UPDATED',
    created_date: '2024-11-08T13:19:53.648Z',
    modified_date: '2024-11-08T13:19:53.648Z',
    is_read: false,
    post: {
      id_slug: 'post-0',
      tags: [
        {
          id_slug: 'tag-class-0',
          slug_name: 'kydp_cada_sept_24',
          name: 'KYDP CADA September Intake 2024',
          description: ''
        }
      ],
      author: tempUser,
      title: 'This is the title of the post',
      description: 'This is the description of the post',
      created_date: '2024-12-08T13:19:53.648Z',
      modified_date: '2024-12-08T13:19:53.648Z'
    }
  },
  // There is a new comment in a post - not your post
  {
    id: 'noti-1',
    user: tempUser,
    notification_type: 'NEW_COMMENT',
    created_date: '2024-12-09T13:19:53.648Z',
    modified_date: '2024-12-09T13:19:53.648Z',
    is_read: false,
    comment_reply: {
      id_slug: 'comment-0',
      created_date: '2024-12-08T13:19:53.648Z',
      modified_date: '2024-12-08T13:19:53.648Z',
      post: {
        id_slug: 'post-0',
        title: 'This is the title of the post that the comment has commented on.'
      },
      author: {
        profile_image: '/images/landing/landing-page/community/landing-community-21.png',
        first_name: 'Jennie',
        last_name: 'Kim',
        user_roles: ['STUDENT']
      },
      description: 'This is the comment',
      is_answer: false,
      upvote_count: 10,
      downvote_count: 5,
      total_vote_count: 5,
      is_hidden: false
    }
  },
  // There is a new comment in a post - your comment
  {
    id: 'noti-2',
    user: tempUser,
    notification_type: 'NEW_COMMENT',
    created_date: '2024-12-07T13:19:53.648Z',
    modified_date: '2024-12-07T13:19:53.648Z',
    is_read: false,
    comment_reply: {
      id_slug: 'comment-0',
      created_date: '2024-12-08T13:19:53.648Z',
      modified_date: '2024-12-08T13:19:53.648Z',
      post: {
        id_slug: 'post-0',
        title: 'This is the title of the post that the comment has commented on.'
      },
      author: tempUser,
      description: 'This is the comment',
      is_answer: false,
      upvote_count: 10,
      downvote_count: 5,
      total_vote_count: 5,
      is_hidden: false
    }
  },
  // There is a new reply in a post - not your post
  {
    id: 'noti-3',
    user: tempUser,
    notification_type: 'NEW_REPLY',
    created_date: '2024-12-06T13:19:53.648Z',
    modified_date: '2024-12-06T13:19:53.648Z',
    is_read: false,
    comment_reply: {
      id_slug: 'comment-0',
      created_date: '2024-12-08T13:19:53.648Z',
      modified_date: '2024-12-08T13:19:53.648Z',
      post: {
        id_slug: 'post-0',
        title: 'This is the title of the post that the comment has commented on.'
      },
      parent_comment: {
        id_slug: 'comment-0',
        created_date: '2024-12-08T13:19:53.648Z',
        modified_date: '2024-12-08T13:19:53.648Z',
        post: {
          id_slug: 'post-0',
          title: 'This is the title of the post that the comment has commented on.'
        },
        author: {
          profile_image: '/images/landing/landing-page/community/landing-community-3.png',
          first_name: 'Rose',
          last_name: 'Kim',
          user_roles: ['STUDENT']
        },
        description: 'This is the comment the reply has replied to',
        is_answer: false,
        upvote_count: 10,
        downvote_count: 5,
        total_vote_count: 5,
        is_hidden: false
      },
      author: {
        profile_image: '/images/landing/landing-page/community/landing-community-3.png',
        first_name: 'Rose',
        last_name: 'Kim',
        user_roles: ['STUDENT']
      },
      description: 'This is the comment',
      is_answer: false,
      upvote_count: 10,
      downvote_count: 5,
      total_vote_count: 5,
      is_hidden: false
    }
  },
  // There is a new reply to your comment
  {
    id: 'noti-4',
    user: tempUser,
    notification_type: 'NEW_REPLY',
    created_date: '2024-12-05T13:19:53.648Z',
    modified_date: '2024-12-05T13:19:53.648Z',
    is_read: false,
    comment_reply: {
      id_slug: 'comment-0',
      created_date: '2024-12-08T13:19:53.648Z',
      modified_date: '2024-12-08T13:19:53.648Z',
      post: {
        id_slug: 'post-0',
        title: 'This is the title of the post that the comment has commented on.'
      },
      parent_comment: {
        id_slug: 'comment-0',
        created_date: '2024-12-08T13:19:53.648Z',
        modified_date: '2024-12-08T13:19:53.648Z',
        post: {
          id_slug: 'post-0',
          title: 'This is the title of the post that the comment has commented on.'
        },
        author: tempUser,
        description: 'This is the comment the reply has replied to',
        is_answer: false,
        upvote_count: 10,
        downvote_count: 5,
        total_vote_count: 5,
        is_hidden: false
      },
      author: {
        profile_image: '/images/landing/landing-page/community/landing-community-4.png',
        first_name: 'Lisa',
        last_name: 'Kim',
        user_roles: ['STUDENT']
      },
      description: 'This is the comment',
      is_answer: false,
      upvote_count: 10,
      downvote_count: 5,
      total_vote_count: 5,
      is_hidden: false
    }
  },
  // Post have answer - not your post
  {
    id: 'noti-5',
    user: tempUser,
    notification_type: 'POST_HAVE_ANSWER',
    created_date: '2024-12-04T13:19:53.648Z',
    modified_date: '2024-12-04T13:19:53.648Z',
    is_read: true,
    post: {
      id_slug: 'post-0',
      tags: [
        {
          id_slug: 'tag-class-0',
          slug_name: 'kydp_cada_sept_24',
          name: 'KYDP CADA September Intake 2024',
          description: ''
        }
      ],
      author: {
        profile_image: '/images/landing/landing-page/community/landing-community-5.png',
        first_name: 'Hanni',
        last_name: 'Kim',
        user_roles: ['STUDENT']
      },
      title: 'This is the title of the post that is now answered',
      description: 'This is the description of the post',
      created_date: '2024-12-08T13:19:53.648Z',
      modified_date: '2024-12-08T13:19:53.648Z'
    }
  },
  // Post have answer - your post
  {
    id: 'noti-6',
    user: tempUser,
    notification_type: 'POST_HAVE_ANSWER',
    created_date: '2024-02-03T13:19:53.648Z',
    modified_date: '2024-02-03T13:19:53.648Z',
    is_read: false,
    post: {
      id_slug: 'post-0',
      tags: [
        {
          id_slug: 'tag-class-0',
          slug_name: 'kydp_cada_sept_24',
          name: 'KYDP CADA September Intake 2024',
          description: ''
        }
      ],
      author: tempUser,
      title: 'This is the title of the post that is now answered',
      description: 'This is the description of the post',
      created_date: '2024-12-08T13:19:53.648Z',
      modified_date: '2024-12-08T13:19:53.648Z'
    }
  },
  // New support post
  {
    id: 'noti-7',
    user: tempUser,
    notification_type: 'NEW_SUPPORT_POST',
    created_date: '2024-12-02T13:19:53.648Z',
    modified_date: '2024-12-02T13:19:53.648Z',
    is_read: true,
    post: {
      id_slug: 'post-0',
      tags: [
        {
          id_slug: 'tag-class-0',
          slug_name: 'kydp_cada_sept_24',
          name: 'KYDP CADA September Intake 2024',
          description: ''
        }
      ],
      author: {
        profile_image: '/images/landing/landing-page/community/landing-community-6.png',
        first_name: 'Haerin',
        last_name: 'Kim',
        user_roles: ['STUDENT']
      },
      title: 'This is a new support post in the class',
      description: 'This is the description of the post',
      created_date: '2024-12-08T13:19:53.648Z',
      modified_date: '2024-12-08T13:19:53.648Z'
    }
  },
  // New class announcement
  {
    id: 'noti-8',
    user: tempUser,
    notification_type: 'NEW_ANNOUNCEMENT',
    created_date: '2024-12-01T13:19:53.648Z',
    modified_date: '2024-12-01T13:19:53.648Z',
    is_read: true,
    post: {
      id_slug: 'post-0',
      tags: [
        {
          id_slug: 'tag-class-0',
          slug_name: 'kydp_cada_sept_24',
          name: 'KYDP CADA September Intake 2024',
          description: ''
        }
      ],
      author: {
        profile_image: '/images/landing/landing-page/community/landing-community-7.png',
        first_name: 'Yujin',
        last_name: 'Ahn',
        user_roles: ['STUDENT']
      },
      title: 'This is a new announcement in the class',
      description: 'This is the description of the post',
      created_date: '2024-12-08T13:19:53.648Z',
      modified_date: '2024-12-08T13:19:53.648Z'
    }
  },
  // Report is submitted - about a post
  {
    id: 'noti-9',
    user: tempUser,
    notification_type: 'REPORT_SUBMITED',
    created_date: '2024-11-25T13:19:53.648Z',
    modified_date: '2024-11-25T13:19:53.648Z',
    is_read: true,
    report: {
      id: 'report-0',
      reporter: tempUser,
      post: {
        id_slug: 'post-0',
        tags: [
          {
            id_slug: 'tag-class-0',
            slug_name: 'kydp_cada_sept_24',
            name: 'KYDP CADA September Intake 2024',
            description: ''
          }
        ],
        author: {
          profile_image: '/images/landing/landing-page/community/landing-community-1.png',
          first_name: 'Jisoo',
          last_name: 'Kim',
          user_roles: ['STUDENT']
        },
        title: 'This is the title of the post',
        description: 'This is the description of the post',
        created_date: '2024-12-08T13:19:53.648Z',
        modified_date: '2024-12-08T13:19:53.648Z'
      }
    }
  },
  // Report is submitted - about a comment
  {
    id: 'noti-10',
    user: tempUser,
    notification_type: 'REPORT_SUBMITED',
    created_date: '2024-11-24T13:19:53.648Z',
    modified_date: '2024-11-24T13:19:53.648Z',
    is_read: true,
    report: {
      id: 'report-0',
      reporter: tempUser,
      comment_reply: {
        id_slug: 'comment-0',
        created_date: '2024-12-08T13:19:53.648Z',
        modified_date: '2024-12-08T13:19:53.648Z',
        post: {
          id_slug: 'post-0',
          title: 'This is the title of the post that the comment has commented on.'
        },
        author: {
          profile_image: '/images/landing/landing-page/community/landing-community-2.png',
          first_name: 'Jennie',
          last_name: 'Kim',
          user_roles: ['STUDENT']
        },
        description: 'This is the comment',
        is_answer: false,
        upvote_count: 10,
        downvote_count: 5,
        total_vote_count: 5,
        is_hidden: false
      }
    }
  },
  // Your content, a post, is reported - content hidden
  {
    id: 'noti-11',
    user: tempUser,
    notification_type: 'CONTENT_REPORTED_HIDDEN',
    created_date: '2024-11-23T13:19:53.648Z',
    modified_date: '2024-11-23T13:19:53.648Z',
    is_read: true,
    report: {
      id: 'report-0',
      reporter: {
        profile_image: '/images/landing/landing-page/community/landing-community-1.png',
        first_name: 'Jisoo',
        last_name: 'Kim',
        user_roles: ['STUDENT']
      },
      post: {
        id_slug: 'post-0',
        tags: [
          {
            id_slug: 'tag-class-0',
            slug_name: 'kydp_cada_sept_24',
            name: 'KYDP CADA September Intake 2024',
            description: ''
          }
        ],
        author: tempUser,
        title: 'This is the title of the post',
        description: 'This is the description of the post',
        created_date: '2024-12-08T13:19:53.648Z',
        modified_date: '2024-12-08T13:19:53.648Z'
      }
    }
  },
  // Your content, a comment, is reported - content hidden
  {
    id: 'noti-12',
    user: tempUser,
    notification_type: 'CONTENT_REPORTED_HIDDEN',
    created_date: '2024-11-22T13:19:53.648Z',
    modified_date: '2024-11-22T13:19:53.648Z',
    is_read: true,
    report: {
      id: 'report-0',
      reporter: {
        profile_image: '/images/landing/landing-page/community/landing-community-1.png',
        first_name: 'Jisoo',
        last_name: 'Kim',
        user_roles: ['STUDENT']
      },
      comment_reply: {
        id_slug: 'comment-0',
        created_date: '2024-12-08T13:19:53.648Z',
        modified_date: '2024-12-08T13:19:53.648Z',
        post: {
          id_slug: 'post-0',
          title: 'This is the title of the post that the comment has commented on.'
        },
        author: tempUser,
        description: 'This is the comment',
        is_answer: false,
        upvote_count: 10,
        downvote_count: 5,
        total_vote_count: 5,
        is_hidden: false
      }
    }
  },
  // Your content, a post, is deleted
  {
    id: 'noti-13',
    user: tempUser,
    notification_type: 'CONTENT_DELETED',
    created_date: '2024-11-21T13:19:53.648Z',
    modified_date: '2024-11-21T13:19:53.648Z',
    is_read: true,
    report: {
      id: 'report-0',
      reporter: {
        profile_image: '/images/landing/landing-page/community/landing-community-1.png',
        first_name: 'Jisoo',
        last_name: 'Kim',
        user_roles: ['STUDENT']
      },
      post: {
        id_slug: 'post-0',
        tags: [
          {
            id_slug: 'tag-class-0',
            slug_name: 'kydp_cada_sept_24',
            name: 'KYDP CADA September Intake 2024',
            description: ''
          }
        ],
        author: tempUser,
        title: 'This is the title of the post',
        description: 'This is the description of the post',
        created_date: '2024-12-08T13:19:53.648Z',
        modified_date: '2024-12-08T13:19:53.648Z'
      }
    }
  },
  // Your content, a comment, is hidden
  {
    id: 'noti-14',
    user: tempUser,
    notification_type: 'CONTENT_DELETED',
    created_date: '2024-11-20T13:19:53.648Z',
    modified_date: '2024-11-20T13:19:53.648Z',
    is_read: true,
    report: {
      id: 'report-0',
      reporter: {
        profile_image: '/images/landing/landing-page/community/landing-community-1.png',
        first_name: 'Jisoo',
        last_name: 'Kim',
        user_roles: ['STUDENT']
      },
      comment_reply: {
        id_slug: 'comment-0',
        created_date: '2024-12-08T13:19:53.648Z',
        modified_date: '2024-12-08T13:19:53.648Z',
        post: {
          id_slug: 'post-0',
          title: 'This is the title of the post that the comment has commented on.'
        },
        author: tempUser,
        description: 'This is the comment',
        is_answer: false,
        upvote_count: 10,
        downvote_count: 5,
        total_vote_count: 5,
        is_hidden: false
      }
    }
  }
]
